/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Button, ButtonGroup, Typography } from '@material-ui/core';

import useStyles from './styles';
import { DeleteOutline, FileCopyOutlined } from '@material-ui/icons';

interface OutputConsoleProps {
  messages: Record<any, string>[];
  clearLogs: () => void;
  isDisabled: boolean;
}

const OutputConsole = (props: OutputConsoleProps) => {
  const classes = useStyles();
  const { messages, clearLogs, isDisabled } = props;

  const handleCopyClick = () => {
    const allMessagesString = messages
      .map((msg) => `${msg.timestamp} ${msg.message}`)
      .join('\n');
    navigator.clipboard.writeText(allMessagesString);
  };

  return (
    <Box className={classes.outputConsoleContainer}>
      <Typography variant="body1">
        <FormattedMessage
          id="modules.testComponent.WebsocketViewer.OutputConsole.Output"
          defaultMessage="Output"
        />
      </Typography>
      <ButtonGroup className={classes.outputButtons}>
        <Button
          variant="text"
          disabled={isDisabled}
          onClick={handleCopyClick}
          startIcon={<FileCopyOutlined />}
          color="primary"
          className={classes.clearOutput}
        >
          <Typography variant="body1">
            <FormattedMessage
              id="modules.testComponent.WebsocketViewer.OutputConsole.copyOutput"
              defaultMessage="Copy Output"
            />
          </Typography>
        </Button>
        <Button
          variant="text"
          onClick={clearLogs}
          disabled={isDisabled}
          startIcon={< DeleteOutline />}
          color="inherit"
          className={classes.deleteButton}
        >
          <Typography variant="body1">
            <FormattedMessage
              id="modules.testComponent.WebsocketViewer.OutputConsole.Delete"
              defaultMessage="Clear"
            />
          </Typography>
        </Button>
      </ButtonGroup>
    </Box>
  );
};
export default OutputConsole;
